module.exports = __webpack_public_path__ + "static/media/order-service-bullets-active.32521223.svg";